export default __webpack_public_path__ + "static/media/jc-mini-logo-white.4b8d4639.svg";